export interface KeyValueLine {
  key: string;
  value: string;
}

interface ParseKeyValueLinesOptions {
  fieldName?: string;
  rejectInvalid?: boolean;
}

export function parseKeyValueLines(
  input: unknown,
  options: ParseKeyValueLinesOptions = {}
): KeyValueLine[] {
  const { fieldName = "Key/value field", rejectInvalid = false } = options;
  const rows: KeyValueLine[] = [];

  String(input || "")
    .split("\n")
    .filter((line) => line.trim())
    .forEach((line, index) => {
      const parts = line.split(":").map((part) => part.trim());
      const [key = "", value = ""] = parts;
      if (rejectInvalid && (parts.length !== 2 || !key || !value)) {
        throw new Error(`${fieldName} line ${index + 1} must use key:value.`);
      }
      if (!line.includes(":")) {
        return;
      }
      rows.push({ key, value });
    });

  return rows;
}
